import { Benefit } from '../benefit';
import { EmploymentType } from '../candidate';
import { Department } from '../department';
import { CareType, Employer } from '../employer';
import { EntityWithTitle } from '../general/entity-with-title';
import { JobPositionStatus, JobTitlesEntity, SalaryElement, ShiftType } from '../job-position';
import { JobTitleEnum } from '../job-title';
import { GeoLocation } from '../location';
import { Match } from '../match';
import { EducationPayment, ExtraPayment } from '../payment';

export interface TemplateMessage {
  text?: string;
  updatedAt: Date;
}

export interface OpeningHours {
  dayOfWeek: string;
  openingTime: string;
  closingTime: string;
}

export interface JobPosition {
  id: string;
  active: boolean;
  basicSalary: number;
  salaryLow?: number;
  title: string;
  slug: string;
  careShare: number;
  employmentTypes?: EmploymentType[];
  departments?: Department[];
  contractTypes?: EntityWithTitle[];
  salaryHigh: number;
  vacationDays?: string;
  canStartDate: string;
  salaryElements?: SalaryElement[];
  shiftDurationHours?: number;
  canStartNow: boolean;
  geoLocation: GeoLocation;
  whatADayLooksLike: string;
  templateMessages?: TemplateMessage[];
  whatADayLooksLikeImageKey?: string;
  educationPayments?: EducationPayment[];
  extraPayments?: ExtraPayment[];
  jobTitles?: JobTitlesEntity[];
  employer: Employer;
  matches?: Match[];
  match?: Match;
  showSalary?: boolean;
  showSalaryDetails: boolean;
  salaryLastChangedAt?: Date;
  experienceSalary: number;
  professionalSalary: number;
  fullTimeHours: number;
  partTimeHours?: number;
  showTimes: boolean;
  shiftType: ShiftType;
  additionalSalaryInformation?: string;
  additionalInformation: string;
  newPosition?: boolean;
  nightsPerMonth: number;
  recommended?: boolean;
  weekendsPerMonth: number;
  shiftCount: number;
  shift1Start: Date;
  shift1End: Date;
  shift2Start: Date;
  shift2End: Date;
  shift3Start: Date;
  shift3End: Date;
  candidateProfile: string[];
  responsibilities: string[];
  benefits: Benefit[];
  onboardingProcedure: string;
  onboardingProcedureImageKey?: string;
  howIWorkDescription?: string;
  status?: JobPositionStatus;
  lastStatusChange?: Date;
  beds?: string;
  teamSize?: string;
  applicationProcess?: string;
  numberOfDoctors?: string;
  showOpeningHours: boolean;
  openingHours?: OpeningHours[];
  publishOnGoogleJobs?: boolean;
  headline?: string;
  metaDescription?: string;
  organicSessions?: number | null;
  isInitiative?: boolean;
  updatedAt: string;
  createdAt: string;
}

export interface JobPositionForCandidateDto {
  id: string;
  distance: number;
  recommended: boolean;
  newPosition: boolean;
  employer: Employer;
  pendingInviteDate?: Date;
  match?: Match;
  jobPosition: JobPosition;
  selected?: boolean;
  score: number;
}

export const DEFAULT_PUSH_LIMIT_PER_KAM_PER_DAY = 20;
export const DEFAULT_PUSH_LIMIT_PER_JOB_PER_DAY_PER_EMPLOYER = 1;
export const B_PRIORITY_PUSH_LIMITED_JOBS = [JobTitleEnum.ElderlyCareNurse, JobTitleEnum.Nurse, JobTitleEnum.PediatricNurse];
export const B_PRIORITY_JOBS_KEY = 'bJobs';
export const CARE_TYPES_WITH_DEPARTMENTS_ENABLED: CareType[] = [
  CareType.Leasing,
  CareType.Hospital,
  CareType.RehabClinic,
  CareType.DoctorOffice,
  CareType.DentalPractice,
] as const;
